import { useState } from "react";
import { CHORE_THEMES } from "@/lib/themes";

// A spinnable SVG wheel of chore segments.
const PALETTE = ["#FFB800", "#FF5A8B", "#8B5CF6", "#10B981", "#3B82F6", "#FF7A00"];

export function ChoreWheel({ chores = [], spinning, rotation, onSpin, disabled }) {
  const n = Math.max(chores.length, 1);
  const seg = 360 / n;
  const R = 150;
  const C = 160;

  const arc = (i) => {
    const start = (i * seg - 90) * (Math.PI / 180);
    const end = ((i + 1) * seg - 90) * (Math.PI / 180);
    const x1 = C + R * Math.cos(start);
    const y1 = C + R * Math.sin(start);
    const x2 = C + R * Math.cos(end);
    const y2 = C + R * Math.sin(end);
    const large = seg > 180 ? 1 : 0;
    return `M${C},${C} L${x1},${y1} A${R},${R} 0 ${large} 1 ${x2},${y2} Z`;
  };

  const labelPos = (i) => {
    const mid = (i * seg + seg / 2 - 90) * (Math.PI / 180);
    return {
      x: C + R * 0.62 * Math.cos(mid),
      y: C + R * 0.62 * Math.sin(mid),
      rot: i * seg + seg / 2,
    };
  };

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="relative" style={{ width: 320, height: 340 }}>
        {/* pointer */}
        <div
          className="wheel-pointer absolute left-1/2 -translate-x-1/2 z-20"
          style={{ top: -4 }}
        >
          <svg width="34" height="40" viewBox="0 0 34 40">
            <polygon points="17,40 2,4 32,4" fill="#0F172A" />
            <polygon points="17,34 8,8 26,8" fill="#FFB800" />
          </svg>
        </div>
        <svg
          width="320"
          height="320"
          viewBox="0 0 320 320"
          className="mt-3"
          style={{
            transform: `rotate(${rotation}deg)`,
            transition: spinning ? "transform 4s cubic-bezier(0.17,0.67,0.24,1)" : "none",
          }}
        >
          <circle cx="160" cy="160" r="156" fill="#0F172A" />
          {chores.map((c, i) => {
            const theme = CHORE_THEMES[c.theme] || CHORE_THEMES.washing_up;
            const p = labelPos(i);
            const emoji = theme.emojis[0];
            return (
              <g key={c.id}>
                <path d={arc(i)} fill={PALETTE[i % PALETTE.length]} stroke="#0F172A" strokeWidth="2" />
                <text
                  x={p.x}
                  y={p.y}
                  fill="#0F172A"
                  fontSize="18"
                  fontWeight="700"
                  textAnchor="middle"
                  transform={`rotate(${p.rot}, ${p.x}, ${p.y})`}
                >
                  {emoji}
                </text>
              </g>
            );
          })}
          {chores.length === 0 && (
            <text x="160" y="165" fill="#fff" fontSize="16" textAnchor="middle">
              No chores yet
            </text>
          )}
          <circle cx="160" cy="160" r="26" fill="#fff" stroke="#0F172A" strokeWidth="3" />
        </svg>
      </div>
      <button
        data-testid="spin-wheel-btn"
        onClick={onSpin}
        disabled={disabled || spinning}
        className="btn-tactile bg-[#FF7A00] text-white px-10 py-3 text-lg"
      >
        {spinning ? "Spinning…" : "🎡 SPIN THE WHEEL"}
      </button>
    </div>
  );
}
